import { render } from "./MicrosoftView.vue?vue&type=template&id=4f4107e2"
import script from "./MicrosoftView.vue?vue&type=script&lang=js"
export * from "./MicrosoftView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__